import { jsxs as h, Fragment as p, jsx as e } from "react/jsx-runtime";
import { Slot as C } from "@radix-ui/react-slot";
import { forwardRef as A, Children as j, isValidElement as E, cloneElement as I } from "react";
import { c as f } from "./cn-DlLpp5ix.js";
import { F } from "./focus-BJKdC9pu.js";
const L = f(
  "group relative flex items-center gap-2 w-full",
  "px-3 py-2.5 min-h-[44px]",
  // 44px tall — accessibility.md §8 + recon
  "rounded-lg",
  "text-sm font-medium",
  "border border-transparent",
  "transition-colors duration-fast ease-out",
  "cursor-pointer text-secondary",
  "hover:bg-bg-hover hover:text-primary",
  "active:bg-bg-active",
  "data-[disabled=true]:cursor-not-allowed data-[disabled=true]:text-tertiary data-[disabled=true]:pointer-events-none",
  // active state — accent dim bg, accent foreground.
  "data-[active=true]:bg-accent-dim data-[active=true]:text-primary data-[active=true]:border-accent-border",
  F
), _ = A(function(x, i) {
  const {
    icon: s,
    children: l,
    active: o = !1,
    badge: t = null,
    badgeContent: a,
    alertLabel: d,
    asChild: g = !1,
    disabled: r = !1,
    className: v,
    type: N,
    ...c
  } = x, m = {
    "data-active": o || void 0,
    "data-disabled": r || void 0
  }, u = {
    "aria-current": o ? "page" : void 0,
    "aria-disabled": r || void 0
  }, b = f(L, v), w = /* @__PURE__ */ h(p, { children: [
    /* @__PURE__ */ e("span", { className: "inline-flex items-center text-current shrink-0", "aria-hidden": "true", children: s }),
    /* @__PURE__ */ e("span", { className: "flex-1 min-w-0 break-words leading-tight", children: l }),
    t === "dot" && /* @__PURE__ */ e(
      "span",
      {
        "aria-hidden": "true",
        className: "ml-auto inline-block w-1.5 h-1.5 rounded-full bg-accent shrink-0"
      }
    ),
    t === "alert" && /* @__PURE__ */ e(
      "span",
      {
        role: "img",
        "aria-label": d ?? "requires attention",
        className: "ml-auto inline-block w-2 h-2 rounded-full bg-error shadow-ring-attention shrink-0"
      }
    ),
    t === "count" && a !== void 0 && /* @__PURE__ */ e(
      "span",
      {
        className: "ml-auto inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-2xs font-semibold rounded-md bg-bg-elevated text-secondary border border-subtle shrink-0",
        "aria-hidden": "false",
        children: a
      }
    )
  ] });
  if (g) {
    const n = j.only(l);
    if (!E(n)) return null;
    const k = n.props, y = /* @__PURE__ */ h(p, { children: [
      /* @__PURE__ */ e("span", { className: "inline-flex items-center text-current shrink-0", "aria-hidden": "true", children: s }),
      /* @__PURE__ */ e("span", { className: "flex-1 min-w-0 break-words leading-tight", children: k.children }),
      t === "dot" && /* @__PURE__ */ e(
        "span",
        {
          "aria-hidden": "true",
          className: "ml-auto inline-block w-1.5 h-1.5 rounded-full bg-accent shrink-0"
        }
      ),
      t === "alert" && /* @__PURE__ */ e(
        "span",
        {
          role: "img",
          "aria-label": d ?? "requires attention",
          className: "ml-auto inline-block w-2 h-2 rounded-full bg-error shadow-ring-attention shrink-0"
        }
      ),
      t === "count" && a !== void 0 && /* @__PURE__ */ e("span", { className: "ml-auto inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-2xs font-semibold rounded-md bg-bg-elevated text-secondary border border-subtle shrink-0", children: a })
    ] }), S = I(n, void 0, y);
    return /* @__PURE__ */ e(C, { ref: i, className: b, ...m, ...u, ...c, children: S });
  }
  return /* @__PURE__ */ e(
    "button",
    {
      ref: i,
      type: N ?? "button",
      className: b,
      disabled: r,
      ...m,
      ...u,
      ...c,
      children: w
    }
  );
});
_.displayName = "NavItem";
export {
  _ as N
};
//# sourceMappingURL=NavItem-DAyxUEph.js.map
